import React, { PureComponent } from "react";
import axios from "axios";

import { Portal } from "../Components/Portal";
import { Checkout } from "../Checkout/Checkout";
import AddToCart from "../ProductActions/AddToCart";
import withDataLayer from "../HOCs/withDataLayer";
import document from "global/document";

const AddToCartWithDataLayer = withDataLayer(AddToCart);

let addToCartPortalRoot, checkoutPortalRoot;

if (document.querySelector) {
    addToCartPortalRoot = document.querySelector("#product-actions");
}

if (document.querySelector) {
    checkoutPortalRoot = document.querySelector("#checkout");
}

class ShoppingCart extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showItems: false,
            isLoading: false,
            items: [],
            totalPrice: 0.0
        };
        this.fetchItems = this.fetchItems.bind(this);
        this.handleUpdateCart = this.handleUpdateCart.bind(this);
    }
    componentDidMount() {
        this.setState(
            {
                isLoading: true
            },
            this.fetchItems()
        );
    }
    fetchItems() {
        axios
            .get("/cart")
            .then(response => {
                let items = response.data.items;

                if (items) {
                    let prices = items.map(item => {
                        return item.price * item.qty;
                    });
                    let totalPrice = this.sum(prices);

                    this.setState({
                        items: items,
                        totalPrice: totalPrice,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        isLoading: false
                    });
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({
                    isLoading: false
                });
            });
    }
    render() {
        return (
            <div className="cart">
                <a className="btn btn-lx-secondary" href="/checkout/cart">
                    {this.state.isLoading && (
                        <div>
                            <i className="fas fa-spinner-third fa-spin" />
                        </div>
                    )}
                    {!this.state.isLoading && (
                        <div>
                            <i className="far fa-shopping-cart" />
                        </div>
                    )}
                </a>
                <div className="cart-info">
                    <strong className="cart-title">shopping cart</strong>
                    <div className="cart-detail">
                        {`${this.state.items.length} item${
                            this.state.items.length != 1 ? "s" : ""
                        } - $${this.state.totalPrice.toFixed(2)}`}
                    </div>
                </div>
                {addToCartPortalRoot &&
                    (addToCartPortalRoot.dataset &&
                        (addToCartPortalRoot.dataset.quote_status == "0" && (
                            <Portal node="#product-actions">
                                <AddToCartWithDataLayer
                                    passHasAdded={this.handleUpdateCart}
                                    {...addToCartPortalRoot.dataset}
                                />
                            </Portal>
                        )))}
                {checkoutPortalRoot &&
                    (checkoutPortalRoot.dataset &&
                        (checkoutPortalRoot.dataset.cart && (
                            <Portal node="#checkout">
                                <Checkout
                                    initialCart={
                                        checkoutPortalRoot.dataset.cart
                                            ? JSON.parse(
                                                checkoutPortalRoot.dataset
                                                    .cart
                                            )
                                            : {}
                                    }
                                    initialTotals={
                                        checkoutPortalRoot.dataset.totals
                                            ? JSON.parse(
                                                checkoutPortalRoot.dataset
                                                    .totals
                                            )
                                            : []
                                    }
                                    initialSellers={
                                        checkoutPortalRoot.dataset.sellers
                                            ? JSON.parse(
                                                checkoutPortalRoot.dataset
                                                    .sellers
                                            )
                                            : []
                                    }
                                    isCustomer={
                                        checkoutPortalRoot.dataset.iscustomer
                                    }
                                    didFetch={() => this.handleUpdateCart()}
                                />
                            </Portal>
                        )))}
            </div>
        );
    }
    handleUpdateCart() {
        this.fetchItems();
    }
    sum(arr) {
        let sum = 0;

        for (let item of arr) {
            sum += item;
        }
        return sum;
    }
}

export { ShoppingCart };
